import React, { Component }  from 'react';
import Footer from '../components/layout/footer';
import Header from '../components/layout/header';
import Faculty from '../components/section/faculties';
import Parents from '../components/section/parents';
 import config from '../constant';


class FacultyMain extends Component {
    componentDidMount(){
        document.title = "Faculties | " + config.SIE_NAME
      }
        render(){
    return(
        <div>
            <Header/>
            <Faculty/>
             <Footer/>


        </div>
    );

}
    }
export default FacultyMain;